module.exports = __webpack_public_path__ + "media/images/help/faq-sticker-status-b30d9bde48eed69bb908d22b15034380.jpg";